import React from 'react'
import About from './About'

const AboutContainer: React.FC = () => {
  return <About />
}

export default AboutContainer
